import { useEffect, useState } from 'react'

import { IntroContainer } from 'components/intro-container'
import {
  Gradient,
  TitleContainer,
  Title,
  Subtitle,
} from 'components/intro-container/styled'
import backgroundL from './images/Background_L.webp'
import backgroundM from './images/Background_M.webp'
import backgroundS from './images/Background_S.webp'
import figuresL from './images/Figures_L.webp'
import figuresM from './images/Figures_M.webp'
import figuresS from './images/Figures_S.webp'
import womanL from './images/Woman_L.webp'
import womanM from './images/Woman_M.webp'
import womanS from './images/Woman_S.webp'
import { AnimationContainer, Background, Figures, Woman } from './styled'
import { useAppContext } from 'context/app-context'

export const Animation = () => {
  const { setLoading, isPageVisible } = useAppContext()
  const [loadedImages, setLoadedImages] = useState(0)

  const onLoadImages = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setLoadedImages((loadedImages) => loadedImages + 1)
  }

  useEffect(() => {
    if (loadedImages === 3) {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedImages])

  return (
    <IntroContainer>
      <AnimationContainer>
        <picture>
          <source
            srcSet={backgroundS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={backgroundM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Background alt="" src={backgroundL} onLoad={onLoadImages} />
        </picture>
        <picture>
          <source
            srcSet={figuresS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={figuresM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Figures
            alt=""
            src={figuresL}
            onLoad={onLoadImages}
            $isPageVisible={isPageVisible}
          />
        </picture>

        <picture>
          <source
            srcSet={womanS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={womanM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Woman
            alt=""
            src={womanL}
            onLoad={onLoadImages}
            $isPageVisible={isPageVisible}
          />
        </picture>
      </AnimationContainer>
      <Gradient />
      <TitleContainer $hidden={isPageVisible}>
        <Title>"Каждая женщина заслуживает жить спокойно и достойно"</Title>
        <Subtitle>
          Спустя десять лет насилия Айзат спасла себя и теперь помогает другим
        </Subtitle>
      </TitleContainer>
    </IntroContainer>
  )
}
